import axiosInstance from '../../utils/axios';

export const roleManagementService = {
  getTeamMembers: async () => {
    try {
      const response = await axiosInstance.get('/agent/team');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch team members' };
    }
  },

  addTeamMember: async (userData) => {
    try {
      const response = await axiosInstance.post('/agent/team', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to add team member' };
    }
  },

  createTeamMember: async (userData) => {
    try {
      const response = await axiosInstance.post('/agent/team', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to add team member' };
    }
  },

  deleteTeamMember: async (id) => {
    try {
      const response = await axiosInstance.delete(`/agent/team/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete team member' };
    }
  }
};

export default roleManagementService;
